export const ADDRESS_QUERY_KEY = 'RPWA_ADDRESS_QUERY_';
export const PLACE_KEY = 'RPWA_PLACE_'
export const SEARCH_REFERENCE = 'RPWA_REF_';
export const OUTOFBOUNDS_DEPOTS_KEY = 'RPWA_DEPOT_';
export const DEPOTS_AT_AREA_KEY = 'RPWA_DEPOTS_AT_AREA';
